<form
  [formGroup]="valueForm"
  (submit)="save($event)"
  class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 px-4 backdrop-blur-sm">
  <div class="w-full max-w-[450px] rounded-2xl bg-white p-8 shadow-2xl">
    <div class="mb-6 flex items-center justify-between border-b pb-4">
      <h4 class="text-[20px] font-bold text-gray-800">
        @if (editData()) {
          <span i18n="@@value.modal.editTitle">Edit Value</span>
        } @else {
          <span i18n="@@value.modal.addTitle">Add New Value</span>
        }
      </h4>
      <button
        type="button"
        (click)="close()"
        class="cursor-pointer text-2xl font-bold text-gray-400 transition-colors hover:text-red-500">
        ×
      </button>
    </div>

    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1.5">
        <label class="text-text-gray text-[14px] font-bold" i18n="@@value.field.en">Attribute Value (English)</label>
        <input
          type="text"
          formControlName="inputEn"
          placeholder="Enter value in English (optional)"
          i18n-placeholder="@@value.placeholder.en"
          class="placeholder-text-placeholder w-full rounded-xl border bg-white px-4 py-3 text-sm text-gray-700 transition-all outline-none"
          [class.border-red-400]="invalid('inputEn')"
          [class.border-gray-200]="!invalid('inputEn')" />

        @if (invalid("inputEn")) {
          <div class="flex flex-col">
            @if (err("inputEn", "maxlength")) {
              <span class="text-xs font-medium text-red-500" i18n="@@value.validation.maxLength">
                Maximum 100 characters allowed
              </span>
            } @else if (err("inputEn", "englishCharacters")) {
              <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.onlyEnglish">
                Please enter English characters only
              </span>
            } @else if (err("inputEn", "alreadyExists")) {
              <span class="text-xs font-medium text-red-500" i18n="@@value.validation.alreadyExists">
                This value already exists
              </span>
            }
          </div>
        }
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-text-gray text-[14px] font-bold">
          <span i18n="@@value.field.ar">Attribute Value (Arabic)</span>
          <span class="text-red-500">*</span>
        </label>
        <input
          type="text"
          dir="rtl"
          formControlName="inputAr"
          placeholder="Enter value in Arabic"
          i18n-placeholder="@@value.placeholder.ar"
          class="placeholder-text-placeholder w-full rounded-xl border bg-white px-4 py-3 text-sm text-gray-700 transition-all outline-none"
          [class.border-red-400]="invalid('inputAr')"
          [class.border-gray-200]="!invalid('inputAr')" />

        @if (invalid("inputAr")) {
          <div class="flex flex-col">
            @if (err("inputAr", "required")) {
              <span class="text-xs font-medium text-red-500" i18n="@@value.validation.arRequired">
                Arabic value is required
              </span>
            } @else if (err("inputAr", "maxlength")) {
              <span class="text-xs font-medium text-red-500" i18n="@@value.validation.maxLength">
                Maximum 100 characters allowed
              </span>
            } @else if (err("inputAr", "arabicCharacters")) {
              <span class="text-xs font-medium text-red-500" i18n="@@attr.validation.onlyArabic">
                Please enter Arabic characters only
              </span>
            } @else if (err("inputAr", "alreadyExists")) {
              <span class="text-xs font-medium text-red-500" i18n="@@value.validation.alreadyExists">
                This value already exists
              </span>
            }
          </div>
        }
      </div>
    </div>

    <div class="mt-8 flex gap-4">
      <button
        type="button"
        (click)="close()"
        class="flex-1 cursor-pointer rounded-xl border border-gray-200 py-3 font-bold text-gray-500 transition-all hover:bg-gray-50"
        i18n="@@product.button.cancel">
        Cancel
      </button>
      <button
        type="submit"
        [disabled]="valueForm.invalid"
        class="bg-primary hover-bg-primary-hover flex-1 cursor-pointer rounded-xl py-3 font-bold text-white shadow-lg transition-all disabled:opacity-50">
        @if (editData()) {
          <span i18n="@@value.button.update">Update Value</span>
        } @else {
          <span i18n="@@value.button.save">Save Value</span>
        }
      </button>
    </div>
  </div>
</form>
